<template>
    <div class="register-content">
        <content-header left-div="back" right-div="guidance" title="내 동화 만들기" v-on:openGuidance="openGuidance" />

        <div class="input-title">제목</div>
        <div class="input-text">
            <input v-model="memberCourse.course_name" type="text" placeholder="제목을 입력해 주세요." />
        </div>

        <!-- <div class="input-title">카테고리</div>
        <div class="input-select">
            <select v-model="memberCourse.category">
                <option value="">카테고리선택</option>
                <option value="001">일상</option>
                <option value="002">유머</option>
                <option value="003">학업</option>
                <option value="004">기타</option>
            </select>
        </div> -->

        <!-- <div class="input-title">들려주고 싶은 대상</div>
        <div class="input-select-2">
            <select v-model="memberCourse.school_div" @change="changeSchoolDiv">
                <option value="">학교선택</option>
                <option value="10">초등</option>
                <option value="20">중등</option>
            </select>
            <select v-model="memberCourse.school_grade" @change="changeSchoolGrade">
                <option value="">학년선택</option>
                <option value="00">전체</option>
                <option v-show="memberCourse.school_div === '10' || memberCourse.school_div === '20'" value="01">1학년</option>
                <option v-show="memberCourse.school_div === '10' || memberCourse.school_div === '20'" value="02">2학년</option>
                <option v-show="memberCourse.school_div === '10' || memberCourse.school_div === '20'" value="03">3학년</option>
                <option v-show="memberCourse.school_div === '10'" value="04">4학년</option>
                <option v-show="memberCourse.school_div === '10'" value="05">5학년</option>
                <option v-show="memberCourse.school_div === '10'" value="06">6학년</option>
            </select>
        </div> -->

        <div class="input-title">오디오 등록</div>
        <div class="input-file">
            <div class="file-name" v-if="memberCourse.audio_url !== ''">
                <ion-chip color="secondary">
                    <ion-label>{{ memberCourse.audio_name }}</ion-label>
                    <ion-icon @click="deleteAudioUpload" name="close-circle"></ion-icon>
                </ion-chip>
            </div>
            <div class="file-button" v-else>
                <ion-button @click="audioUpload" size="small" color="medium" fill="outline">파일 불러오기</ion-button>
            </div>
        </div>

        <!-- <div class="input-title">키워드</div>
        <div class="input-text">
            <input v-model="memberCourse.keyword" type="text" placeholder="키워드를 입력해 주세요." />
        </div>
        <div class="input-example">예) 삼각형, 국어, 고민 등</div> -->

        <div class="input-title">썸네일 등록</div>
        <div class="input-file">
            <div class="file-button">
                <ion-button @click="imageUpload" size="small" color="medium" fill="outline">파일 불러오기</ion-button>
                <ion-button @click="sampleImageUpload" size="small" color="medium" fill="outline">동화 이용</ion-button>
            </div>
            <div class="file-image" v-if="memberCourse.thumb_url !== ''">
                <ion-thumbnail>
                    <img v-bind:src="memberCourse.thumb_url">
                </ion-thumbnail>
                <div class="file-image-delete">
                    <ion-icon @click="deleteImageUpload" name="close-circle"></ion-icon>
                </div>
            </div>
        </div>

        <footer-two-buttonbar left-label="취소" right-label="참여하기" v-bind:is-fixed="true" v-bind:disabled="isNextButtonDisabled" v-on:leftButtonEvent="leftClickEvent" v-on:rightButtonEvent="rightClickEvent" />
    </div>
</template>

<script>
    import * as biz from '../../utils/biz';
    import * as ajax from '../../utils/ajax';
    import * as alert from '../../utils/alert';
    import ContentHeader from "../../components/header/ContentHeader";
    import FooterTwoButtonbar from "../../components/footer/FooterTwoButtonbar";
    import * as utils from "../../utils/utils";

    export default {
        name: "RegisterContent",
        components: {ContentHeader, FooterTwoButtonbar},
        data() {
            return {
                sample_thumb_url: "https://ba8hb5guu4.ecn.cdn.ofs.kr/images/sample/member-course.png",
                memberCourse: {
                    category: "001",
                    course_name: "",
                    school_div: "10",
                    school_grade: "00",
                    school_grade1: "N",
                    school_grade2: "N",
                    school_grade3: "N",
                    school_grade4: "N",
                    school_grade5: "N",
                    school_grade6: "N",
                    keyword: "",
                    audio_url: "",
                    audio_name: "",
                    thumb_url: "",
                    thumb_name: ""
                }
            }
        },
        created() {
            if (!biz.isLogin(this))
                this.$router.push("/login");

            this.$store.state.toolbarActivePosition = "join";
            this.$store.state.basicPlayerVisiblity = false;
        },
        mounted() {
            window.audioInfo = this.audioInfo;
            window.galleryInfo = this.galleryInfo;
        },
        methods: {
            openGuidance() {
                this.$router.push('/mycontent/guidance');
            },
            audioUpload() {
                console.log("call audioUpload");
                switch(utils.deviceInfo()) {
                    case "Android":
                        window.listenApp.audioUpload();
                        break;
                    case "iOS":
                        window.webkit.messageHandlers.audioUpload.postMessage("");
                        break;
                }
                // Only Android Webview
                // if (navigator.userAgent.match(/Android/i) && navigator.userAgent.match(/wv/i)) {
                //     window.listenApp.audioUpload();
                // }
            },
            audioInfo(url) {
                const splitUrl = url.split("/");
                const audioFileName = splitUrl[splitUrl.length-1];

                this.memberCourse.audio_url = url;
                this.memberCourse.audio_name = audioFileName;
            },
            deleteAudioUpload() {
                this.memberCourse.audio_url = "";
                this.memberCourse.audio_name = "";
            },
            sampleImageUpload() {
                this.memberCourse.thumb_url = this.sample_thumb_url;
            },
            imageUpload() {
                console.log("call imageUpload");
                switch(utils.deviceInfo()) {
                    case "Android":
                        window.listenApp.invokeGallery();
                        break;
                    case "iOS":
                        window.webkit.messageHandlers.invokeGallery.postMessage("");
                        break;
                }
                // Only Android Webview
                // if (navigator.userAgent.match(/Android/i) && navigator.userAgent.match(/wv/i)) {
                //     window.listenApp.invokeGallery();
                // }
            },
            galleryInfo(url) {
                const splitUrl = url.split("/");
                const imageFileName = splitUrl[splitUrl.length-1];

                this.memberCourse.thumb_url = url;
                this.memberCourse.thumb_name = imageFileName;
            },
            deleteImageUpload() {
                this.memberCourse.thumb_url = "";
            },
            leftClickEvent() {
                this.$router.push('/mycontent/main');
            },
            rightClickEvent() {
                const params = this.memberCourse;
                ajax.Post(this, "/api/contents/member/course/", params, function(ref, data) {
                    alert.alert("참여하기가 등록 되었습니다.", "확인");
                    ref.$router.go(-1);
                });
            },
            changeSchoolDiv() {
                this.memberCourse.school_grade = "";
                this.changeSchoolGrade();
            },
            changeSchoolGrade() {
                this.memberCourse.school_grade1 = 'N';
                this.memberCourse.school_grade2 = 'N';
                this.memberCourse.school_grade3 = 'N';
                this.memberCourse.school_grade4 = 'N';
                this.memberCourse.school_grade5 = 'N';
                this.memberCourse.school_grade6 = 'N';

                switch (this.memberCourse.school_grade) {
                    case "00":
                        this.memberCourse.school_grade1 = 'Y';
                        this.memberCourse.school_grade2 = 'Y';
                        this.memberCourse.school_grade3 = 'Y';

                        if (this.memberCourse.school_div === '10') {
                            this.memberCourse.school_grade4 = 'Y';
                            this.memberCourse.school_grade5 = 'Y';
                            this.memberCourse.school_grade6 = 'Y';
                        }
                        break;
                    case "01":
                        this.memberCourse.school_grade1 = 'Y';
                        break;
                    case "02":
                        this.memberCourse.school_grade2 = 'Y';
                        break;
                    case "03":
                        this.memberCourse.school_grade3 = 'Y';
                        break;
                    case "04":
                        this.memberCourse.school_grade4 = 'Y';
                        break;
                    case "05":
                        this.memberCourse.school_grade5 = 'Y';
                        break;
                    case "06":
                        this.memberCourse.school_grade6 = 'Y';
                        break;
                }
            }
        },
        computed: {
            isNextButtonDisabled() {
                return !(this.memberCourse.category && this.memberCourse.course_name !== '' && this.memberCourse.school_div !== ''
                    && this.memberCourse.school_grade !== '' && this.memberCourse.audio_url !== '' && this.memberCourse.thumb_url !== '');
            }
        }
    }
</script>

<style scoped lang="scss">
    div.register-content {
        overflow-y: auto;
        padding-bottom: 110px;

        div.input-title {
            margin: 24px 24px 0 24px;
            font-weight: 400;
        }
        div.input-example {
            margin: 8px 24px 0 24px;
            font-size: $font-base14;
            color: $font-third-color;
        }
        div.input-text, div.input-select {
            margin: 0 24px;
            border-bottom: 1px solid #989aa2;
            input {
                width: 100%;
                padding: 8px 0;
                border: 0;
            }
            input:focus {
                outline: none;
            }
            select {
                width: 100%;
                padding: 8px 0;
            }
        }
        div.input-select-2 {
            display: flex;
            justify-content: space-between;
            margin: 0 24px;
            border-bottom: 1px solid #989aa2;

            select {
                width: 50%;
                padding: 8px 0;
            }
        }
        div.input-file {
            margin: 12px 24px;

            div.file-button {
            }
            div.file-name {
            }
            div.file-image {
                position: relative;
                width: 85px;
                height: 85px;
                margin: 10px 0 0 0;

                ion-thumbnail {
                    --border-radius: 10px;
                    --size: 85px;
                }
                img {
                    filter: brightness(70%);
                }
                div.file-image-delete {
                    position: absolute;
                    top: 5px;
                    right: 5px;
                }
            }
        }
    }

</style>